import { createPersonalListFilter } from '../../factories';
import { fetchPersonalList } from '../../services/personalList';

import { PersonalLineupEntry, PersonalLineupQueryData } from './types';

type FetchPersonalListArgs = {
  listType: number;
};

export async function fetchPersonalLineup({ listType }: FetchPersonalListArgs): Promise<PersonalLineupQueryData> {
  const { objects } = await fetchPersonalList({
    filter: createPersonalListFilter({
      orderBy: 'CREATE_DATE_DESC',
      partnerListTypeIn: String(listType),
    }),
  });

  if (!objects.length) {
    return {
      allLineups: [],
      dictionary: new Map(),
      entries: [],
      highestChannelNumber: 0,
    };
  }

  const latestPersonalLineup = objects[0];
  // lineups are needed in order to clean up obsolete one after a new lineup submitted by user
  const allLineups = objects.map((i) => i.id);

  try {
    const json = JSON.parse(latestPersonalLineup.ksql) as { UserPersonalLineup?: Array<Record<string, number>> };
    const userPersonalLineup = json.UserPersonalLineup;

    if (!userPersonalLineup) {
      return {
        allLineups,
        entries: [],
        dictionary: new Map(),
        highestChannelNumber: 0,
      };
    }

    const entries: Array<PersonalLineupEntry> = [];
    const dictionary: Map<number, number> = new Map();
    let highestChannelNumber = 0;

    for (let i = 0; i < userPersonalLineup.length; i++) {
      const [[channelId, channelNumber]] = Object.entries(userPersonalLineup[i]);

      const entry = {
        channelId: Number(channelId),
        channelNumber,
      };

      if (channelNumber > highestChannelNumber) {
        highestChannelNumber = channelNumber;
      }

      entries.push(entry);
      dictionary.set(entry.channelId, entry.channelNumber);
    }

    return {
      allLineups,
      dictionary,
      entries,
      highestChannelNumber,
    };
  } catch (error) {
    return {
      allLineups,
      dictionary: new Map(),
      entries: [],
      highestChannelNumber: 0,
    };
  }
}
